import { client } from '@atlassian/rovo-content-bridge-api';

const CONFLUENCE_DATABASE_CLIENT_ID_PREFIX = 'confluence-database';

export const getConfluenceDatabaseClientId = (contentId: string) =>
	client(`${CONFLUENCE_DATABASE_CLIENT_ID_PREFIX}-${contentId}`);
